import React, { useState, useCallback, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import {
  useMediaQuery,
  Typography,
  Card,
  Stack,
  Box,
  TextField,
  FormGroup, 
  FormControlLabel, 
  Checkbox,
  Button, 
  ButtonBase
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAuth0 } from "@auth0/auth0-react";
import SignUpBackground from "src/public/assets/illustrations/signupBackground.png";
import SignupDesktop from "./SignupDesktop";

import SignupMobile from "./SignupMobile";
import handleSubmit from "./components/api/handleSubmit.js"
import { useNavigate } from 'react-router-dom'; 
import { useAccountContext } from "src/context/AccountContext";




const StyledRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",



  fontFamily: "'Lato', sans-serif",
  backgroundColor: '#F7FBFC'
});

export default function Signup() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
          const [confirmPassword, setConfirmPassword] = useState("");
                  const [showPassword, setShowPassword] = useState("")
                  const [showConfirmPassword, setShowConfirmPassword] = useState("")
      const [termsAccepted, setTermsAccepted] = useState(false);





    const [errors, setErrors] = useState({
    firstName: "",
    lastName : "",
    email    : "",
    password : "",
    confirmPassword : "",
    termsAccepted: "",
    generic: "",
  });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [complete, setComplete] = useState(false);
  


  



  





    const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";


    const handleSignIn = () => {
    window.location.href = auth0LoginUrl;
  };



















const handleCreateNewUser = async (e) => {
  if (complete) {
    handleSignIn();
  }
  e.preventDefault();
  setSubmitTick((n) => n + 1);

  const formData = { firstName, lastName, email, password, confirmPassword };

  if (!validate()) {
    setShowErrors(true);
    return;
  }

  // talk to the API …………………………………………………………………………………
  const result = await handleSubmit(setLoading, formData, setComplete);

  // 1️⃣  this component’s own reaction
if (result.error === "Email already exists") {
  setErrors((prev) => ({
    ...prev,
    email: "This email is already in use.",
  }));
  setShowErrors(true);
  return;
} else if (result.error) {
  setErrors((prev) => ({
    ...prev,
    generic: "Unable to create account. Please try again later.",
  }));
  setShowErrors(true);
  return;
}
};






  const [showErrors, setShowErrors] = useState(false); 
  const [submitTick, setSubmitTick] = useState(0); 
  
    const validate = () => {
      const next = {};
  
      // 1 – Required names
      if (!firstName.trim()) next.firstName = "First name is required";
      if (!lastName.trim())  next.lastName  = "Last name is required";
  
      // 2 – Email format
      const emailRx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRx.test(email)) next.email = "Enter a valid e-mail address";
  
      // 3 – Password rules
      if (password.length < 8) {
        next.password = "Password must be at least 8 characters long";
      } else {
        let strength = 0;
        if (/[a-z]/.test(password))       strength++;   // lower
        if (/[A-Z]/.test(password))       strength++;   // upper
        if (/[0-9]/.test(password))       strength++;   // digit
        if (/[!@#$%^&*]/.test(password))  strength++;   // special
        if (strength < 3) {
          next.password =
            "Password must contain: lowercase, uppercase, number, special char";
        }
      }
  
      // 4 – Confirm match
      if (confirmPassword !== password) {
        next.confirmPassword = "Passwords do not match";
      }

        /* 5 — Terms acceptance (desktop / tablet only) */
  if (!isMobile && !termsAccepted) {
    next.termsAccepted = "You must accept the terms & conditions";
  }
  
      setErrors(next);
      return Object.keys(next).length === 0;
    };


const capitalize = (str = "") =>
  str.length ? str[0].toUpperCase() + str.slice(1) : str;



const emailRx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const passwordStrengthOk = (pwd) => {
  if (pwd.length < 8) return false;
  let score = 0;
  if (/[a-z]/.test(pwd))      score++;
  if (/[A-Z]/.test(pwd))      score++;
  if (/[0-9]/.test(pwd))      score++;
  if (/[!@#$%^&*]/.test(pwd)) score++;
  return score >= 3;
};

// convenient utility so we don’t repeat the `setErrors` pattern
const patchErrors = (field, isValid, message) =>
  setErrors(prev => {
    const next = { ...prev };
    if (isValid)      delete next[field];
    else              next[field] = message;
    return next;
  });



// Reusable pattern: 0–20 characters, letters (any case) or “-”
const NAME_REGEX = /^[A-Za-z-]{0,20}$/;

const sanitizeName = raw =>
  raw                       // original keystrokes
    .replace(/[^A-Za-z-]/g, '')  // strip everything except letters + dash
    .slice(0, 20);               // enforce 20-char max

const handleFirstNameChange = e => {
  const cleaned = sanitizeName(e.target.value);

  // optional extra guard: don’t update state if pattern fails
  if (!NAME_REGEX.test(cleaned)) return;

  const val = capitalize(cleaned);
  setFirstName(val);
  patchErrors('firstName', Boolean(val.trim()), 'First name is required');
};

const handleLastNameChange = e => {
  const cleaned = sanitizeName(e.target.value);
  if (!NAME_REGEX.test(cleaned)) return;

  const val = capitalize(cleaned);
  setLastName(val);
  patchErrors('lastName', Boolean(val.trim()), 'Last name is required');
};




const handleEmailChange = (e) => {
  const val = e.target.value;
  setEmail(val);
  patchErrors("email", emailRx.test(val), "Enter a valid e-mail address");
};

const handlePasswordChange = (e) => {
  const val = e.target.value;
  setPassword(val);

  // validate password itself
  patchErrors(
    "password",
    passwordStrengthOk(val),
    "Password must be ≥8 chars and include lower, upper, number & special"
  );

  // also re-validate confirmPassword, because the reference changed
  patchErrors(
    "confirmPassword",
    confirmPassword === val,
    "Passwords do not match"
  );
};

const handleConfirmPasswordChange = (e) => {
  const val = e.target.value;
  setConfirmPassword(val);
  patchErrors(
    "confirmPassword",
    val === password,
    "Passwords do not match"
  );
};

// the two eye-toggle handlers don’t affect validation — keep as is
const handleTogglePassword = useCallback(
  () => setShowPassword(prev => !prev),
  []
);
const handleToggleConfirmPassword = useCallback(
  () => setShowConfirmPassword(prev => !prev),
  []
);

const handleTermsAcceptedChange = (e) => {
  const checked = e.target.checked;
  setTermsAccepted(checked);
  patchErrors(
    "termsAccepted",
    checked || isMobile,                // mobile doesn’t require it
    "You must accept the terms & conditions"
  );
};


  const { isAuthenticated, user } = useAuth0();
  const { accountData } = useAccountContext();


  const navigate = useNavigate();        


  useEffect(() => {
    if (accountData) {
      navigate('/dashboard/app');              
    }
  }, []);  


  




  return (
    <>

      <Helmet>
        <title>SignUp | NanoNotify.io</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
          {!accountData && (
      <StyledRoot>
        {isMobile ? <SignupMobile
          handleSubmit={handleCreateNewUser}
          submitTick={submitTick}
          errors={errors}
          setErrors={setErrors}
          validate={validate}
          showErrors={showErrors}
          setShowErrors={setShowErrors}
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          handleFirstNameChange={handleFirstNameChange}
          handleLastNameChange={handleLastNameChange}
          handleEmailChange={handleEmailChange}
          handlePasswordChange={handlePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          showConfirmPassword={showConfirmPassword}
          setShowConfirmPassword={setShowConfirmPassword}
          handleTogglePassword={handleTogglePassword}
          handleToggleConfirmPassword={handleToggleConfirmPassword}
          loading={loading}
          setLoading={setLoading}
          complete={complete}

        
        /> : 
        
        <SignupDesktop
                handleSubmit={handleCreateNewUser}
          submitTick={submitTick}
          errors={errors}
          setErrors={setErrors}
          validate={validate}
          showErrors={showErrors}
          setShowErrors={setShowErrors}
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          handleFirstNameChange={handleFirstNameChange}
          handleLastNameChange={handleLastNameChange}
          handleEmailChange={handleEmailChange}
          handlePasswordChange={handlePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          showConfirmPassword={showConfirmPassword}
          setShowConfirmPassword={setShowConfirmPassword}
          handleTogglePassword={handleTogglePassword}
          handleToggleConfirmPassword={handleToggleConfirmPassword}
          handleTermsAcceptedChange={handleTermsAcceptedChange}
        termsAccepted={termsAccepted}  
        setTermsAccepted={setTermsAccepted}
        loading={loading}
        complete={complete}
        
         />}

         
      </StyledRoot>
    )}
    </>
  );
}